import React, { Component } from "react";
import _ from "underscore";
import { titleize, humanize } from "underscore.string";
import DropdownButton from 'components/ui/tailwind/DropdownButton';

const EquipmentTypes = [{
  name: 'ISO Dry',
  value: 'ISO Dry',
}, {
  name: 'ISO Dry',
  value: 'ISO Dry',
}, {
  name: 'ISO High Cube',
  value: 'ISO High Cube',
}, {
  name: 'ISO Reefer',
  value: 'ISO Reefer',
}, {
  name: 'Domestic',
  value: 'Domestic',
}, {
  name: 'Domestic Reefer',
  value: 'Domestic Reefer',
}, {
  name: 'Other',
  value: 'Other',
}];


const EquipmentParentTypes = [{
  name: 'Container',
  value: 'container',
}, {
  name: 'Chassis',
  value: 'chassis',
}, {
  name: 'Trailer',
  value: 'trailer',
}];

const RadioSlider = (props) => (
  <div className="mb-2">
    <div className="form-switch inline-block align-middle" onClick={() => props.onChange(!props.checked)}>
      <input
        type="checkbox"
        name="1"
        id="1"
        checked={props.checked}
        className="form-switch-checkbox"
      />
      <label className="form-switch-label" for="1"></label>
    </div>
    <label className="text-xs text-grey-dark" for="1"></label>
  </div>
);

export default class EquipmentViewRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      equipment: {
        owner: this.props.equipment.owner,
        equipment_id: this.props.equipment.equipment_id,
        _type: this.props.equipment._type,
        _equipmentType: this.props.equipment._equipmentType,
        _equipmentSize: this.props.equipment._equipmentSize,
        life: this.props.equipment.life,
        available: true,
        _id: this.props.equipment._id,
      }
    };
  }

  handleUpdateAvailable(checked) {
    const equipment = { ...this.state.equipment};
    equipment.available = checked;
    this.setState({equipment});
    this.props.equipmentUpdate(this.state.equipment);
  }

  render() {
    if (!this.state.equipment) return null;

    const equipment = this.state.equipment;

    return (
      <div className="mt-2">
        <div className="flex text-grey-darker">
          <div className="w-1/4">
            <div className="w-1/2">
              <input
                placeholder="Equipment ID"
                disabled={true}
                className="w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker"
                value={equipment.equipment_id || ""}
              />
            </div>
          </div>
          <div className="w-1/4">
            <div className="w-1/2">
              <input
                placeholder="Equipment Type"
                disabled={true}
                className="w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker"
                value={equipment._equipmentType || ""}
              />
            </div>
          </div>
          <div className="w-1/4">
            <div className="w-1/2">
              <input
                placeholder="Type"
                disabled={true}
                className="w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker"
                value={equipment._type || ""}
              />
            </div>
          </div>
          <div className="w-1/4">
            <div className="w-1/2">
              <input
                placeholder="Size"
                disabled={true}
                className="w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker"
                value={equipment._equipmentSize || ""}
              />
            </div>
          </div>
          <div className="w-1/4">
            <div className="w-1/2">
              <input
                placeholder="Owner"
                disabled={true}
                className="w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker"
                value={equipment.owner || ""}
                onChange={(e) => {this.state.equipment.owner = e.target.value; this.setState({equipment: this.state.equipment}); this.props.equipmentUpdate(this.state.equipment)}}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
